import React from "react";

export default function SQL_Training() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Training</h1>
      <p>This is the SQL_Training component generated from the SQL JSON.</p>
    </div>
  );
}
